(()=>{
  const clone=o=>JSON.parse(JSON.stringify(o));
  const round=value=>Math.round(value*100000)/100000;
  let fullState=null;
  let focusState={front:[1,1,1,1],back:[1,1,1,1]};
  let adjustState={fit:{front:[false,false,false,false],back:[false,false,false,false]},scale:{front:[100,100,100,100],back:[100,100,100,100]}};

  function root(){return document.querySelector('[data-hfd]');}
  function side(){return root()?.querySelector('[data-side].is-active')?.dataset.side||'front';}
  function count(){return +(root()?.querySelector('[data-count].is-active')?.dataset.count||1);}
  function cross(){return root()?.querySelector('[data-cross].is-active')?.dataset.cross||'single';}
  function split(){return 'line';}
  function lineSize(){return +(root()?.querySelector('[data-line-size]')?.value||16);}
  function lineColor(){return root()?.querySelector('[data-line-color]')?.value||'#087df5';}

  function presentationFor(layer,img){
    if(!layer||!img)return null;
    const lr=layer.getBoundingClientRect(),ir=img.getBoundingClientRect();
    if(!lr.width||!lr.height||!ir.width||!ir.height)return null;
    return {
      x:round((ir.left-lr.left)/lr.width),
      y:round((ir.top-lr.top)/lr.height),
      w:round(ir.width/lr.width),
      h:round(ir.height/lr.height)
    };
  }

  function visibleBoundsFor(img){
    try{return img?.dataset?.visibleBounds?JSON.parse(img.dataset.visibleBounds):null;}catch(_){return null;}
  }

  function snapshotSide(name){
    const r=root();if(!r)return null;
    const pane=window.hfdUi?.pane(r,name);
    const s=name||side();
    const rows=pane?.rows||[...r.querySelectorAll(`[data-hfd-side="${s}"] [data-select-row]`)];
    const layers=pane?.layers||[...r.querySelectorAll(`[data-hfd-side="${s}"] [data-layer]`)];
    const count=+(pane?.counts?.find(b=>b.classList.contains('is-active'))?.dataset.count
      ||[...r.querySelectorAll(`[data-hfd-side="${s}"] [data-count].is-active`)].pop()?.dataset.count
      ||1);
    const cross=pane?.crosses?.find(b=>b.classList.contains('is-active'))?.dataset.cross
      ||r.querySelector(`[data-hfd-side="${s}"] [data-cross].is-active`)?.dataset.cross
      ||'single';
    const items=rows.slice(0,count).map((row,index)=>{
      const type=row.querySelector('[data-selection-type]')?.value||'country';
      const memory=window.__twoInOneFlagDesignState?.[s]?.items?.[index];
      if(type==='text'||memory?.type==='text'){
        const text=memory?.text??(row.querySelector('.hfd__text-input')?.value||'');
        return {
          type:'text',
          value:'text',
          text,
          font:memory?.font||'sans',
          size:memory?.size||'auto',
          color:memory?.color||'#0a1b43',
          background:memory?.background||'#ffffff',
          align:memory?.align||'center',
          valign:memory?.valign||'middle',
          bold:memory?.bold!==false,
          label:String(text||'Text').split('\n')[0].slice(0,48)||'Text'
        };
      }
      const sel=row.querySelector('[data-flag-selection]');
      const value=sel?.value||r.dataset.visitorCountry||'us';
      const layer=layers[index],img=layer?.querySelector('img');
      const imageUrl=img?.currentSrc||img?.src||row.dataset.libraryImage||'';
      const item={type,value};
      if(memory?.overlay?.text)item.overlay=clone(memory.overlay);
      if(imageUrl&&!imageUrl.startsWith('data:'))item.imageUrl=imageUrl;
      if(type==='upload'||type==='my-uploads'){
        const upload=window.__hfdUploadState?.[s]?.[index];
        item.uploadId=upload?.id||row.dataset.uploadId||'';
        item.name=upload?.name||'';
        item.value=item.uploadId||'upload';
        item.private=!!upload?.private;
      }
      const presentation=presentationFor(layer,img);if(presentation)item.presentation=presentation;
      const visibleBounds=visibleBoundsFor(img);if(visibleBounds)item.visibleBounds=visibleBounds;
      if(img?.naturalWidth)item.naturalWidth=img.naturalWidth;
      if(img?.naturalHeight)item.naturalHeight=img.naturalHeight;
      item.focus=Number(focusState?.[s]?.[index]??1);
      item.fitEntire=!!adjustState?.fit?.[s]?.[index];
      item.scale=Number(adjustState?.scale?.[s]?.[index]??100);
      return item;
    });
    return {
      count,
      cross,
      split:split(),
      lineSize:+(pane?.lineSize?.value||lineSize()),
      lineColor:pane?.lineColor?.value||lineColor(),
      items
    };
  }

  function snapshotCurrent(){return snapshotSide(side());}

  function rememberCurrent(){
    if(window.__hfdRestoring)return;
    ['front','back'].forEach(name=>{
      const current=snapshotSide(name);if(!current)return;
      if(!fullState)fullState={front:null,back:null,side:name};
      fullState[name]=clone(current);
    });
    if(fullState)fullState.side=side();
  }

  function deferredRemember(){
    if(window.__hfdRestoring)return;
    requestAnimationFrame(()=>requestAnimationFrame(rememberCurrent));
  }

  function setSideLock(locked){
    const r=root();if(!r)return;
    r.querySelectorAll('[data-side],[data-swap-sides]').forEach(button=>{
      button.disabled=locked;
      button.setAttribute('aria-disabled',locked?'true':'false');
      button.style.opacity=locked?'.45':'';
      button.style.cursor=locked?'not-allowed':'';
    });
    r.querySelectorAll('[data-reset-side]').forEach(button=>{
      button.disabled=locked;
      button.style.opacity=locked?'.45':'';
      button.style.cursor=locked?'not-allowed':'';
    });
  }

  document.addEventListener('flag:focus-state',e=>{
    if(e.detail?.front&&e.detail?.back)focusState=clone(e.detail);
    if(!document.querySelector('[data-hfd] .is-panning'))deferredRemember();
  });

  document.addEventListener('flag:image-adjust-state',e=>{
    if(e.detail?.fit&&e.detail?.scale)adjustState=clone(e.detail);
    if(e.detail?.print)rememberCurrent();
  });

  document.addEventListener('flag:design-change',e=>{
    if(window.__hfdRestoring)return;
    if(e.detail?.front&&e.detail?.back){
      fullState={front:clone(e.detail.front),back:clone(e.detail.back),side:e.detail.side||side()};
    }
    deferredRemember();
  });

  document.addEventListener('flag:library-rendered',deferredRemember);

  document.addEventListener('click',e=>{
    const sideButton=e.target.closest?.('[data-side]');
    if(sideButton){
      rememberCurrent();
      return;
    }
    if(e.target.closest?.('[data-count],[data-cross]')){
      deferredRemember();
      return;
    }
    if(e.target.closest?.('[data-mode="motion"]')){
      rememberCurrent();setSideLock(true);return;
    }
    if(e.target.closest?.('[data-mode="design"]')){rememberCurrent();setSideLock(false);return;}
  },true);

  window.twoInOneSavedDesignState=()=>{
    // Prefer the designer emit (in-memory designs object) — DOM snapshot alone can still be visitor-country defaults.
    const emitted=window.__twoInOneFlagDesignState;
    if(emitted?.front?.items&&emitted?.back?.items){
      rememberCurrent();
      const merge=(base,extra)=>{
        if(!base)return extra?clone(extra):null;
        const out=clone(base);
        (extra?.items||[]).forEach((item,index)=>{
          if(!out.items?.[index]||!item)return;
          if(item.presentation)out.items[index].presentation=item.presentation;
          if(item.visibleBounds)out.items[index].visibleBounds=item.visibleBounds;
          if(out.items[index].type==='text')delete out.items[index].imageUrl;
          else if(item.imageUrl)out.items[index].imageUrl=item.imageUrl;
          if(item.scale!=null)out.items[index].scale=item.scale;
          if(item.fitEntire!=null)out.items[index].fitEntire=item.fitEntire;
          if(item.focus!=null)out.items[index].focus=item.focus;
        });
        return out;
      };
      return {
        front:merge(emitted.front,fullState?.front),
        back:merge(emitted.back,fullState?.back),
        side:emitted.side||side()
      };
    }
    rememberCurrent();
    return fullState?clone(fullState):null;
  };

  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>setSideLock(false),{once:true});
  else setSideLock(false);
})();
